import { all, call, put, takeEvery } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../utils/axios";
import * as actions from "./actions";

function* getSporexpertUser() {
    try {
        yield put({ type: actions.SET_LOADING_SPOREXPERT_USER });

        const sporexpertuser = yield call(AxiosCall, '/sporexpertuser/get_sporexpertuser_detail/');
        yield put({ type: actions.GET_SPOREXPERT_USER.SUCCESS, sporexpertuser });
    } catch (e) {
        yield put({ type: actions.GET_SPOREXPERT_USER.FAILURE, message: e.message });
    }
}

function* setSporexpertUser(action) {
    // Dummy saga, logic is in JWTContext.js
    try {
        const sporexpertuser = action.payload.sporexpertuser;
        yield put({ type: actions.SET_SPOREXPERT_USER.SUCCESS, sporexpertuser });
    } catch (e) {
        // Error handled silently
    }
}

function* updateSporexpertUser(action) {
    try {
        const { name, country, city } = action.payload.data;
        const result = yield call(AxiosPost, '/sporexpertuser/update_sporexpertuser/', { name, country, city });
        yield put(actions.updateSporexpertUserSuccess(result.data.results.at(0)));
    } catch (e) {
        yield put(actions.updateSporexpertUserFailure(e.message));
    }
}


export default function* sporexpertUserSaga() {
    yield all([
        // watchers sporexpertUsers
        takeEvery(actions.GET_SPOREXPERT_USER.REQUEST, getSporexpertUser),
        takeEvery(actions.SET_SPOREXPERT_USER.REQUEST, setSporexpertUser),
        // udpate
        takeEvery(actions.UPDATE_SPOREXPERT_USER.REQUEST, updateSporexpertUser),
    ])
}
